import React, { useContext } from 'react'
import { TemplateContext } from '../../context/template'
import '../../components/template/template.scss'
import { AppContext } from '../../context/app'
import { useInterval } from '../../hooks/useInterval'
import { useEffect } from 'react'
import { useState } from 'react'
import { isEmpty } from '../../utils/helper'
import { ComponentConfig } from '../../utils/componentConfig'

const TemplateHome = () => {
  const { componentData, refetchTemplateData } = useContext(TemplateContext)
  const { componentCustomForms, accountObj } = useContext(AppContext)
  const [components, setComponents] = useState([])

  useInterval(
    () => {
      if (accountObj?.od_resource_allowances?.content_refresh) {
        refetchTemplateData()
      }
    },
    accountObj?.od_resource_allowances?.content_refresh ? 25000 : null,
  )

  useEffect(() => {
    if (
      !isEmpty(componentData)
      // && !deepArrEqual([...componentData], [...components])
    ) {
      setComponents([...componentData])
    }
  }, [componentData])

  const getComponent = (key, data) => {
    if (!key) return
    let componentProps = {
      componentData: data,
      modifyData: () => {},
      setModalState: () => {},
      isEdit: false,
      onSwap: () => {},
      onDelete: () => {},
      onCopy: () => {},
      onAdd: () => {},
    }
    if (key === 'customForm') {
      const CustomForm = ComponentConfig[key]
      return <CustomForm {...componentProps} formData={componentCustomForms} />
    }

    if (key === 'artistMaxPlayer') {
      const ArtistMax = ComponentConfig.artistMax
      return <ArtistMax {...componentProps} isPlayer={true} />
    }

    if (key === 'artistMaxWithoutText') {
      const ArtistMax = ComponentConfig.artistMax
      return <ArtistMax {...componentProps} isPlayer={true} withoutText={true} />
    }

    // Default case
    const Component = ComponentConfig[key]
    return Component ? <Component {...componentProps} /> : null
  }

  return (
    <div>
      {!isEmpty(components) &&
        components.map((info, index) => getComponent(info?.data?.component_key, info?.data))}
    </div>
  )
}

export default TemplateHome
